import { getToken, getUser } from '@/utils/auth'

export default ({ to, next }) => {
  if (getUser() && getToken() && to.name != 'Login') {
    next('/')
    return false
  }
  next()
}
